import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { QairoLogo } from "../components/QairoLogo";
import { formatApiError } from "../lib/formatApiError";
import { API } from "../lib/constants";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <header className="border-b border-black">
        <div className="max-w-7xl mx-auto px-8 py-4 flex items-center justify-between">
          <Link to="/"><QairoLogo variant="light" /></Link>
          <Link to="/login" className="text-sm font-medium hover:text-[#0066FF]">Back to Login</Link>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="w-full max-w-md">
          <div className="border border-black p-8 rounded-xl">
            <h1 className="text-2xl font-bold mb-2">Forgot Password</h1>
            <p className="text-gray-600 mb-6">Enter your email and we'll send you a reset link.</p>

            {sent ? (
              <div data-testid="forgot-success">
                <div className="bg-green-50 border border-green-500 text-green-700 p-4 mb-4 rounded-lg">
                  If an account with that email exists, we've sent a password reset link. Check your inbox.
                </div>
                <Link to="/login" className="block text-center text-[#0066FF] font-bold hover:underline">
                  Back to Login
                </Link>
              </div>
            ) : (
              <>
                {error && <div className="bg-red-50 border border-red-500 text-red-700 p-3 mb-4 text-sm rounded-lg" data-testid="forgot-error">{error}</div>}
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <label className="text-xs uppercase tracking-[0.2em] font-bold block mb-2">Email Address</label>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="w-full border border-black p-3 focus:ring-2 focus:ring-[#0066FF] outline-none rounded-lg"
                      required
                      data-testid="forgot-email"
                    />
                  </div>
                  <button
                    type="submit"
                    disabled={loading}
                    className="w-full bg-[#0066FF] text-white py-3 font-bold hover:bg-[#0052CC] transition-colors disabled:opacity-50 rounded-lg"
                    data-testid="forgot-submit"
                  >
                    {loading ? "Sending..." : "Send Reset Link"}
                  </button>
                </form>
                <p className="text-center mt-6 text-sm">
                  Remember your password? <Link to="/login" className="text-[#0066FF] font-bold">Login</Link>
                </p>
              </>
            )}
          </div>
        </div>
      </main>

      <footer className="py-8 px-8 border-t border-black bg-black text-white">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <QairoLogo variant="dark" />
          <p className="text-sm text-gray-400">&copy; 2026 QAIRO AI. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
